import service from "@/utils/service.js";

const user = {
  // 定义获取微信登录二维码地址接口
  fetchWeChatQRCode: () => {
    const url = "/sso/getSocialURL";
    const method = "get";
    const params = {
      ContentType: "json",
      client_id: "2d56a12b31aa4033b3bff7fa9e784cf9",
      referer: location.href,
    };
    const config = { url, method, params };
    return service(config);
  },

  // 定义获取用户登录信息接口
  fetchUserInfo: () => {
    const url = "/booklib/v2/chat/init";
    const method = "get";
    const config = { url, method };
    return service(config);
  },

  // 定义退出登录接口
  signOut: () => {
    const url = "/booklib/ajax/invoke";
    const method = "post";
    const headers = { "Content-Type": "application/x-www-form-urlencoded" };
    const data = new URLSearchParams();
    data.append("_ZVING_METHOD", "member/logout");
    data.append("_ZVING_URL", encodeURIComponent(location.pathname));
    data.append(
      "_ZVING_DATA",
      `{"Referer":"${location.origin}${location.pathname}"}`
    );
    data.append("_ZVING_DATA_FORMAT", "json");
    const config = { url, method, headers, data };
    return service(config);
  },

  // 定义获取特殊机构名称列表接口
  fetchSpecialOrganizationNameList: () => {
    const { origin, pathname } = location;
    const url = `${origin}${pathname}config/special-organization-name-list.json`;
    const method = "get";
    const config = { url, method };
    return service(config);
  },
};

export default user;
